import { useState, useEffect } from 'react';

import { CompleteFormData, FormGroupData } from 'components/DynamicFormGroup/types/formTypes';
import { apiForms } from 'services/apiService';

export const useFetchFormsByGroup = (
  user_id: string,
  group_id: string | null = null,
  group_slug: string | null = null
) => {
  const [formGroupId, setFormGroupId] = useState<string | null>(group_id);
  const [formData, setFormData] = useState<CompleteFormData[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFormsByGroup = async (group_id: string) => {
      setLoading(true);
      setError(null);
      try {
        const response = await apiForms.get(
          `/v1/forms/group/${group_id}/complete?user_id=${user_id}`
        );
        const data: CompleteFormData[] = response.data;
        setFormData(data);
      } catch (err: any) {
        setError(err.message || 'Error fetching form data');
        console.error('Error fetching forms by group:', err);
      } finally {
        setLoading(false);
      }
    };

    const fetchFormsByGroupSlug = async () => {
      const response = await apiForms.get(`/v1/groups/all?slug=${group_slug}`);
      const data: FormGroupData[] = response.data;
      const formGroupId = data.find(group => group.slug === group_slug)?.id;
      if (formGroupId) {
        setFormGroupId(formGroupId);
        fetchFormsByGroup(formGroupId);
      }
    };

    if (!group_id && !group_slug) {
      setError('Group ID or group slug is required');
      return;
    }

    if (group_id && user_id) {
      fetchFormsByGroup(group_id);
    } else if (group_slug && user_id) {
      fetchFormsByGroupSlug();
    }
  }, [group_id, user_id, group_slug]);

  return { formData, loading, error, formGroupId };
};

// Keep the old name for backward compatibility
export const useFetchCompleteForm = useFetchFormsByGroup;
